<template>
  <div v-if="place" class="culture-page">
    <CultureNav />
    <CultureHero
      :title="place.name"
      :summary="place.description"
      eyebrow="Reckon Place"
      :image="place.image || fallbackImage"
    />
    <main>
      <v-container>
        <section class="detail-grid">
          <div>
            <p class="kicker">The Place</p>
            <h2>{{ locationLabel || place.name }}</h2>
            <p>{{ place.description }}</p>
          </div>
          <div class="place-actions">
            <strong>{{ place.name }}</strong>
            <span v-if="locationLabel">{{ locationLabel }}</span>
            <a v-if="place.websiteUrl" :href="place.websiteUrl" target="_blank" rel="noopener noreferrer">
              Visit Website <v-icon small>mdi-open-in-new</v-icon>
            </a>
          </div>
        </section>

        <section class="section-block">
          <p class="kicker">Part of the Story</p>
          <h2>Related Reckon Moments</h2>
          <div class="related-grid">
            <CultureCard
              v-for="item in place.related"
              :key="item.id"
              :title="item.title"
              :href="item.route"
              :image="item.image || fallbackImage"
              :eyebrow="item.eyebrow"
              :summary="item.summary"
            />
          </div>
        </section>
      </v-container>
    </main>
    <AppFooter />
  </div>
  <div v-else class="not-found">
    <v-container>
      <h1>Place not found</h1>
      <v-btn :to="{ name: 'reckon-way-places' }">View Places</v-btn>
    </v-container>
  </div>
</template>

<script>
import { mediaRef } from '@/services/mediaAssets';
import AppFooter from '@/components/Footer.vue';
import CultureNav from '@/components/reckon-way/culture/CultureNav.vue';
import CultureHero from '@/components/reckon-way/culture/CultureHero.vue';
import CultureCard from '@/components/reckon-way/culture/CultureCard.vue';
import { placesBySlug } from '@/content/culture/places';

const fallbackImage = mediaRef('adventures/reckon-way-featured-fallback.png');

export default {
  name: 'CulturePlaceDetailView',
  components: {
    AppFooter, CultureNav, CultureHero, CultureCard,
  },
  data: () => ({ fallbackImage }),
  computed: {
    place() { return placesBySlug[this.$route.params.placeSlug]; },
    locationLabel() {
      if (!this.place) return '';
      return [this.place.city, this.place.state, this.place.country].filter(Boolean).join(', ');
    },
  },
};
</script>

<style scoped>
.culture-page, main, .not-found { background: #050505; }
.culture-page main { padding: 64px 0 76px; }
.detail-grid { display: grid; gap: 36px; grid-template-columns: minmax(0, 1.4fr) minmax(260px, .6fr); }
.kicker { color: #e23232; font-family: "Oswald", sans-serif; font-size: .8rem; font-weight: 900; margin: 0 0 7px; text-transform: uppercase; }
h2 { color: #fff; font-family: "Oswald", sans-serif; font-size: 2.4rem; margin: 0 0 18px; }
.detail-grid > div:first-child > p:last-child { color: #c2c2c2; font-size: 1.08rem; line-height: 1.7; }
.place-actions { align-items: flex-start; background: #141414; border: 1px solid #303030; border-radius: 10px; display: flex; flex-direction: column; padding: 24px; }
.place-actions strong { color: #fff; font-size: 1.2rem; }
.place-actions span { color: #999; margin-top: 6px; }
.place-actions a { color: #fff; font-weight: 800; margin-top: 24px; text-decoration: none; text-transform: uppercase; }
.place-actions a .v-icon { color: #e23232; }
.section-block { border-top: 1px solid #292929; margin-top: 60px; padding-top: 52px; }
.related-grid { display: grid; gap: 16px; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); }
.not-found { color: #fff; min-height: 100vh; padding-top: 50px; }
@media (max-width: 700px) { .detail-grid { grid-template-columns: 1fr; } }
</style>
